// @generated by protoc-gen-es v1.2.0 with parameter "target=js+dts"
// @generated from file wavin/aqora/v2/event.proto (package wavin.aqora.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from enum wavin.aqora.v2.Severity
 */
export const Severity = proto3.makeEnum(
  "wavin.aqora.v2.Severity",
  [
    {no: 0, name: "SEVERITY_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SEVERITY_CRITICAL", localName: "CRITICAL"},
    {no: 2, name: "SEVERITY_ERROR", localName: "ERROR"},
    {no: 3, name: "SEVERITY_WARNING", localName: "WARNING"},
    {no: 4, name: "SEVERITY_INFO", localName: "INFO"},
    {no: 5, name: "SEVERITY_DEBUG", localName: "DEBUG"},
  ],
);

/**
 * @generated from enum wavin.aqora.v2.EventType
 */
export const EventType = proto3.makeEnum(
  "wavin.aqora.v2.EventType",
  [
    {no: 0, name: "EVENT_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "EVENT_TYPE_BATTERY_IS_EMPTY", localName: "BATTERY_IS_EMPTY"},
    {no: 2, name: "EVENT_TYPE_BATTERY_IS_LOW", localName: "BATTERY_IS_LOW"},
    {no: 3, name: "EVENT_TYPE_BATTERY_DRAINING", localName: "BATTERY_DRAINING"},
    {no: 4, name: "EVENT_TYPE_WATER_HEIGHT_SENSOR_BROKEN", localName: "WATER_HEIGHT_SENSOR_BROKEN"},
    {no: 5, name: "EVENT_TYPE_DEVICE_OFFLINE", localName: "DEVICE_OFFLINE"},
    {no: 6, name: "EVENT_TYPE_TEMPERATURE_SENSOR_BROKEN", localName: "TEMPERATURE_SENSOR_BROKEN"},
    {no: 7, name: "EVENT_TYPE_VALVE_ACTUATOR_BROKEN", localName: "VALVE_ACTUATOR_BROKEN"},
    {no: 8, name: "EVENT_TYPE_POWER_TURNED_ON", localName: "POWER_TURNED_ON"},
    {no: 9, name: "EVENT_TYPE_PANIC_MODE_ACTIVATED", localName: "PANIC_MODE_ACTIVATED"},
    {no: 10, name: "EVENT_TYPE_USER_CONTROLLER_RESET", localName: "USER_CONTROLLER_RESET"},
    {no: 11, name: "EVENT_TYPE_WATCHDOG_CONTROLLER_RESET", localName: "WATCHDOG_CONTROLLER_RESET"},
    {no: 12, name: "EVENT_TYPE_POWER_SUPPLY_TURNED_OFF", localName: "POWER_SUPPLY_TURNED_OFF"},
    {no: 13, name: "EVENT_TYPE_INCONSISTENT_WATER_HEIGHT_MEASUREMENT", localName: "INCONSISTENT_WATER_HEIGHT_MEASUREMENT"},
    {no: 14, name: "EVENT_TYPE_DEFAULT_SETTINGS_RESTORED", localName: "DEFAULT_SETTINGS_RESTORED"},
    {no: 15, name: "EVENT_TYPE_FIRMWARE_VERSION_PUBLISHED", localName: "FIRMWARE_VERSION_PUBLISHED"},
    {no: 16, name: "EVENT_TYPE_ANALOG_PORT_VALUES_PUBLISHED", localName: "ANALOG_PORT_VALUES_PUBLISHED"},
    {no: 17, name: "EVENT_TYPE_DIGITAL_PORT_VALUES_PUBLISHED", localName: "DIGITAL_PORT_VALUES_PUBLISHED"},
    {no: 18, name: "EVENT_TYPE_TEMPERATURE_ADDRESSES_SENT", localName: "TEMPERATURE_ADDRESSES_SENT"},
    {no: 19, name: "EVENT_TYPE_POWER_ISSUE_DURING_MEASUREMENT", localName: "POWER_ISSUE_DURING_MEASUREMENT"},
    {no: 20, name: "EVENT_TYPE_ROOF_DRY", localName: "ROOF_DRY"},
    {no: 21, name: "EVENT_TYPE_ENABLE_AUTO_MODE_COMMAND_STARTED", localName: "ENABLE_AUTO_MODE_COMMAND_STARTED"},
    {no: 22, name: "EVENT_TYPE_ENABLE_AUTO_MODE_COMMAND_FINISHED", localName: "ENABLE_AUTO_MODE_COMMAND_FINISHED"},
    {no: 23, name: "EVENT_TYPE_OPEN_VALVE_COMMAND_STARTED", localName: "OPEN_VALVE_COMMAND_STARTED"},
    {no: 24, name: "EVENT_TYPE_OPEN_VALVE_COMMAND_FINISHED", localName: "OPEN_VALVE_COMMAND_FINISHED"},
    {no: 25, name: "EVENT_TYPE_CLOSE_VALVE_COMMAND_STARTED", localName: "CLOSE_VALVE_COMMAND_STARTED"},
    {no: 26, name: "EVENT_TYPE_CLOSE_VALVE_COMMAND_FINISHED", localName: "CLOSE_VALVE_COMMAND_FINISHED"},
    {no: 27, name: "EVENT_TYPE_SET_VALVE_HEIGHT_COMMAND_STARTED", localName: "SET_VALVE_HEIGHT_COMMAND_STARTED"},
    {no: 28, name: "EVENT_TYPE_SET_VALVE_HEIGHT_COMMAND_FINISHED", localName: "SET_VALVE_HEIGHT_COMMAND_FINISHED"},
    {no: 29, name: "EVENT_TYPE_OPEN_TAP_COMMAND_STARTED", localName: "OPEN_TAP_COMMAND_STARTED"},
    {no: 30, name: "EVENT_TYPE_OPEN_TAP_COMMAND_FINISHED", localName: "OPEN_TAP_COMMAND_FINISHED"},
    {no: 31, name: "EVENT_TYPE_CLOSE_TAP_COMMAND_STARTED", localName: "CLOSE_TAP_COMMAND_STARTED"},
    {no: 32, name: "EVENT_TYPE_CLOSE_TAP_COMMAND_FINISHED", localName: "CLOSE_TAP_COMMAND_FINISHED"},
    {no: 46, name: "EVENT_TYPE_SET_TAP_COMMAND_STARTED", localName: "SET_TAP_COMMAND_STARTED"},
    {no: 47, name: "EVENT_TYPE_SET_TAP_COMMAND_FINISHED", localName: "SET_TAP_COMMAND_FINISHED"},
    {no: 33, name: "EVENT_TYPE_REQUEST_MEASUREMENT_COMMAND_STARTED", localName: "REQUEST_MEASUREMENT_COMMAND_STARTED"},
    {no: 34, name: "EVENT_TYPE_REQUEST_MEASUREMENT_COMMAND_FINISHED", localName: "REQUEST_MEASUREMENT_COMMAND_FINISHED"},
    {no: 35, name: "EVENT_TYPE_FIRMWARE_UPDATE_REBOOT", localName: "FIRMWARE_UPDATE_REBOOT"},
    {no: 36, name: "EVENT_TYPE_VALVE_SETPOINT_OUT_OF_RANGE", localName: "VALVE_SETPOINT_OUT_OF_RANGE"},
    {no: 37, name: "EVENT_TYPE_VALVE_MOTOR_OVERCURRENT_DETECTED", localName: "VALVE_MOTOR_OVERCURRENT_DETECTED"},
    {no: 38, name: "EVENT_TYPE_SET_MAINTENANCE_MODE_COMMAND_STARTED", localName: "SET_MAINTENANCE_MODE_COMMAND_STARTED"},
    {no: 39, name: "EVENT_TYPE_SET_MAINTENANCE_MODE_COMMAND_FINISHED", localName: "SET_MAINTENANCE_MODE_COMMAND_FINISHED"},
    {no: 40, name: "EVENT_TYPE_DEVICE_LINKED", localName: "DEVICE_LINKED"},
    {no: 41, name: "EVENT_TYPE_DEVICE_UNLINKED", localName: "DEVICE_UNLINKED"},
    {no: 42, name: "EVENT_TYPE_RADAR_SENSOR_BAD_QUALITY", localName: "RADAR_SENSOR_BAD_QUALITY"},
    {no: 43, name: "EVENT_TYPE_DEBUG_DATA", localName: "DEBUG_DATA"},
    {no: 44, name: "EVENT_TYPE_FIRMWARE_UPDATE_FAILED", localName: "FIRMWARE_UPDATE_FAILED"},
    {no: 45, name: "EVENT_TYPE_SYSTEM_CONFIGURATION_UPDATED", localName: "SYSTEM_CONFIGURATION_UPDATED"},
    {no: 48, name: "EVENT_TYPE_SEND_SETTINGS_STARTED", localName: "SEND_SETTINGS_STARTED"},
    {no: 49, name: "EVENT_TYPE_SEND_SETTINGS_FINISHED", localName: "SEND_SETTINGS_FINISHED"},
    {no: 50, name: "EVENT_TYPE_SETTINGS_RECEIVED", localName: "SETTINGS_RECEIVED"},
    {no: 51, name: "EVENT_TYPE_COMMAND_FAILED", localName: "COMMAND_FAILED"},
    {no: 52, name: "EVENT_TYPE_CONVEYOR_PREDICTION", localName: "CONVEYOR_PREDICTION"},
    {no: 53, name: "EVENT_TYPE_CONVEYOR_RULES", localName: "CONVEYOR_RULES"},
    {no: 54, name: "EVENT_TYPE_ROOF_OVERFULL_PREDICTED", localName: "ROOF_OVERFULL_PREDICTED"},
    {no: 55, name: "EVENT_TYPE_SET_PUMP_COMMAND_STARTED", localName: "SET_PUMP_COMMAND_STARTED"},
    {no: 56, name: "EVENT_TYPE_SET_PUMP_COMMAND_FINISHED", localName: "SET_PUMP_COMMAND_FINISHED"},
    {no: 57, name: "EVENT_TYPE_VALVE_SET_POSITION_TIMEOUT", localName: "VALVE_SET_POSITION_TIMEOUT"},
    {no: 58, name: "EVENT_TYPE_ISSUE_MANUAL_CLOSED", localName: "ISSUE_MANUAL_CLOSED"},
    {no: 59, name: "EVENT_TYPE_CONVEYOR_SYSTEM_MODE", localName: "CONVEYOR_SYSTEM_MODE"},
    {no: 60, name: "EVENT_TYPE_VALVE_ACTION_COMPLETE", localName: "VALVE_ACTION_COMPLETE"},
    {no: 61, name: "EVENT_TYPE_WATER_LEVEL_SENSOR_INVALID_READING", localName: "WATER_LEVEL_SENSOR_INVALID_READING"},
    {no: 62, name: "EVENT_TYPE_UPS_BATTERY_FAILURE", localName: "UPS_BATTERY_FAILURE"},
    {no: 63, name: "EVENT_TYPE_FLOW_RATE_VERY_SLOW", localName: "FLOW_RATE_VERY_SLOW"},
    {no: 64, name: "EVENT_TYPE_FLOW_RATE_VERY_FAST", localName: "FLOW_RATE_VERY_FAST"},
    {no: 65, name: "EVENT_TYPE_CONNECTION_RESTORED", localName: "CONNECTION_RESTORED"},
    {no: 66, name: "EVENT_TYPE_CONNECTION_ESTABLISHED", localName: "CONNECTION_ESTABLISHED"},
    {no: 67, name: "EVENT_TYPE_SET_POINT_REACHED", localName: "SET_POINT_REACHED"},
    {no: 68, name: "EVENT_TYPE_DEVICE_SPECIFIC_COMMAND_STARTED", localName: "DEVICE_SPECIFIC_COMMAND_STARTED"},
    {no: 69, name: "EVENT_TYPE_DEVICE_SPECIFIC_COMMAND_FINISHED", localName: "DEVICE_SPECIFIC_COMMAND_FINISHED"},
    {no: 100, name: "EVENT_TYPE_NOTE_ACTION", localName: "NOTE_ACTION"},
    {no: 101, name: "EVENT_TYPE_NOTE_PROBLEM", localName: "NOTE_PROBLEM"},
    {no: 102, name: "EVENT_TYPE_NOTE_OBSERVATION", localName: "NOTE_OBSERVATION"},
  ],
);

/**
 * @generated from enum wavin.aqora.v2.EventConveyorSystemModeValue
 */
export const EventConveyorSystemModeValue = proto3.makeEnum(
  "wavin.aqora.v2.EventConveyorSystemModeValue",
  [
    {no: 0, name: "EVENT_CONVEYOR_SYSTEM_MODE_VALUE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 10, name: "EVENT_CONVEYOR_SYSTEM_MODE_VALUE_OUTSIDE_GROWING", localName: "OUTSIDE_GROWING"},
    {no: 20, name: "EVENT_CONVEYOR_SYSTEM_MODE_VALUE_GROWING", localName: "GROWING"},
    {no: 30, name: "EVENT_CONVEYOR_SYSTEM_MODE_VALUE_FREEZING_PROTECTION", localName: "FREEZING_PROTECTION"},
    {no: 40, name: "EVENT_CONVEYOR_SYSTEM_MODE_VALUE_MANUAL", localName: "MANUAL"},
  ],
);

/**
 * Event is an irregular and infrequent measurement that has occurred over time. The inverse of metric
 *
 * @generated from message wavin.aqora.v2.Event
 */
export const Event = proto3.makeMessageType(
  "wavin.aqora.v2.Event",
  () => [
    { no: 1, name: "resource_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "enum", T: proto3.getEnumType(EventType) },
    { no: 3, name: "severity", kind: "enum", T: proto3.getEnumType(Severity) },
    { no: 4, name: "last_occurance_time", kind: "message", T: Timestamp },
      {no: 6, name: "payload_info", kind: "message", T: Event_PayloadInfo, repeated: true},
      {no: 7, name: "control_source", kind: "enum", T: proto3.getEnumType(Event_ControlSource)},
  ],
);

/**
 * @generated from enum wavin.aqora.v2.Event.ControlSource
 */
export const Event_ControlSource = proto3.makeEnum(
  "wavin.aqora.v2.Event.ControlSource",
  [
    {no: 0, name: "CONTROL_SOURCE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CONTROL_SOURCE_MANUAL", localName: "MANUAL"},
    {no: 2, name: "CONTROL_SOURCE_AUTOMATED", localName: "AUTOMATED"},
  ],
);

/**
 * @generated from message wavin.aqora.v2.Event.PayloadInfo
 */
export const Event_PayloadInfo = proto3.makeMessageType(
  "wavin.aqora.v2.Event.PayloadInfo",
  () => [
      {no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */},
      {no: 2, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */},
  ],
  {localName: "Event_PayloadInfo"},
);

